module.exports = __webpack_public_path__ + "static/pool-61f513d157ce0f19cbefd96fb99d11a5.jpg";